import { Field } from "@rjsf/utils";

import { TitleField } from "./TitleField";
import { MarkdownField } from "./MarkdownField";
import { DateField } from "./DateField";
import { ZipCodeField } from "./ZipCodeField";

interface FieldTemplateRegistry {
  [name: string]: Field;
}

export const Fields: FieldTemplateRegistry = {
  title: TitleField,
  markdown: MarkdownField,
  date: DateField,
  zipCode: ZipCodeField
};
